import { render } from "./CorrectFiveView.vue?vue&type=template&id=6997eca8&scoped=true&ts=true"
import script from "./CorrectFiveView.vue?vue&type=script&lang=ts"
export * from "./CorrectFiveView.vue?vue&type=script&lang=ts"

import "./CorrectFiveView.vue?vue&type=style&index=0&id=6997eca8&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6997eca8"]])

export default __exports__